/**
 * debug-mode-requests.ts
 * Copyright (c) 2017, My Coverage Plan, Inc.
 * All rights reserved.
 */

import { Message, ReplyVerifyingMessage } from "../general/reply-message";
import { MessageTag } from "../message-tag";

export class DebugModeConfigurationRequest extends ReplyVerifyingMessage
{
    public tag : MessageTag = MessageTag.DBG_REQ_CFG_MODE;
	public static tag : MessageTag = MessageTag.DBG_REQ_CFG_MODE;

    constructor (public enableDebug : boolean)
    {
        super();
    }
}

export class DebugCodeGenModeConfigurationRequest extends ReplyVerifyingMessage
{
    public tag : MessageTag = MessageTag.DBG_REQ_CFG_CODE_GEN_MODE;
	public static tag : MessageTag = MessageTag.DBG_REQ_CFG_CODE_GEN_MODE;

    constructor (public enableDebug : boolean)
    {
        super();
    }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/admin/debug-mode-requests.ts